import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetoigatpuri() {



    const cardData = {

keyword: "Pune to Igatpuri Taxi",

headingDescription:
    "Rising Cab Service offers safe and comfortable Pune to Igatpuri Taxi services for families, couples, tourists, and weekend travelers. We provide Sedan, SUV, Innova Crysta, Tempo Traveller, and luxury vehicles for one-way and round-trip journeys with experienced chauffeurs. Our service includes doorstep pickup, 24/7 booking support, transparent pricing, and well-maintained cabs, ensuring a smooth and enjoyable journey from Pune to the scenic hill station of Igatpuri.",

topPlaces: [
    {
        title: "Bhatsa River Valley",
        description:
            "Bhatsa River Valley is one of Igatpuri's most famous viewpoints, offering breathtaking views of deep valleys, winding rivers, and lush green Sahyadri hills. It is especially popular during monsoon when clouds float through the valley, creating a magical landscape perfect for photography and nature lovers."
    },
    {
        title: "Vihigaon Waterfall",
        description:
            "Vihigaon Waterfall, also known as Ashoka Waterfall, is a stunning seasonal waterfall near Igatpuri. Surrounded by dense forests, it becomes a popular spot for rappelling, trekking, and picnics during the monsoon season, attracting adventure seekers and tourists."
    },
    {
        title: "Camel Valley",
        description:
            "Camel Valley is a spectacular viewpoint in Igatpuri known for its dramatic cliffs and the massive waterfall that flows during the rainy season. The valley offers panoramic views of the Western Ghats and is a favorite destination for nature photography."
    },
    {
        title: "Tringalwadi Fort",
        description:
            "Tringalwadi Fort is a historic hill fort located near Igatpuri offering trekking routes, ancient architecture, and panoramic views of the surrounding Sahyadri ranges. The fort holds historical significance from the Maratha era."
    },
    {
        title: "Bhavli Waterfall",
        description:
            "Bhavli Waterfall is a peaceful natural attraction near Igatpuri surrounded by forests and hills. It is an ideal spot for relaxation, nature walks, and enjoying the beauty of the monsoon season."
    },
    {
        title: "Ghatandevi Temple",
        description:
            "Ghatandevi Temple is a sacred temple dedicated to Goddess Ghatandevi, considered the protector of the Igatpuri ghats. Located amidst scenic hills, it offers spiritual peace and beautiful views of the valley."
    },
    {
        title: "Vipassana International Academy",
        description:
            "Vipassana International Academy, also known as Dhamma Giri, is a globally renowned meditation center in Igatpuri. It attracts visitors from around the world who come to learn mindfulness and meditation in a peaceful environment."
    },
    {
        title: "Kalsubai Peak (Nearby)",
        description:
            "Kalsubai Peak is the highest peak in Maharashtra located near Igatpuri. It is a popular trekking destination offering challenging trails and rewarding panoramic views from the summit."
    },
    {
        title: "Arthur Lake",
        description:
            "Arthur Lake is a serene water reservoir surrounded by hills and greenery. It is a peaceful spot for relaxation, photography, and enjoying the natural beauty of Igatpuri."
    },
    {
        title: "Trek to Kavnai Fort",
        description:
            "Kavnai Fort is a lesser-known trekking destination near Igatpuri offering scenic trails, ancient ruins, and stunning views of the surrounding landscape, making it ideal for adventure enthusiasts."
    }
],



services: [
{
name: "Pune to Igatpuri Cab",
description: "Rising Cab Service offers Pune to Igatpuri Cab with safe, comfortable, and affordable travel for families, couples, and weekend travelers. Choose from AC Sedan, SUV, Ertiga, Innova Crysta, and Tempo Traveller options for a smooth hill drive experience with professional drivers and doorstep pickup."
},
{
name: "Pune to Igatpuri Taxi",
description: "Book Pune to Igatpuri Taxi with Rising Cab Service for reliable and stress-free travel. We provide clean vehicles, experienced chauffeurs, transparent pricing, and 24x7 booking support for one way and round trip journeys to Igatpuri and nearby Nashik region."
},
{
name: "Cab from Pune to Igatpuri",
description: "Our Cab from Pune to Igatpuri service ensures comfortable highway travel with flexible pickup and drop locations. Enjoy safe rides in well-maintained AC vehicles suitable for solo, family, and group travel."
},
{
name: "Taxi from Pune to Igatpuri",
description: "Rising Cab Service provides Taxi from Pune to Igatpuri with punctual service, verified drivers, and affordable fares for weekend getaways, sightseeing, and business trips."
},
{
name: "Pune to Igatpuri Cab Service",
description: "Our Pune to Igatpuri Cab Service offers reliable and budget-friendly travel with multiple cab options including Sedan, SUV, Ertiga, and Innova Crysta for a comfortable journey through scenic routes."
},
{
name: "Pune to Igatpuri Taxi Fare",
description: "Get affordable Pune to Igatpuri Taxi Fare with transparent pricing and no hidden charges. We offer economical packages for one way trips, round trips, and weekend holiday travel."
},
{
name: "Pune to Igatpuri One Way Cab",
description: "Book Pune to Igatpuri One Way Cab for convenient and cost-effective travel with flexible pickup and drop service, ideal for solo travelers and quick weekend trips."
},
{
name: "Pune to Igatpuri Round Trip Taxi",
description: "Our Pune to Igatpuri Round Trip Taxi service is perfect for weekend getaways and sightseeing tours with comfortable waiting time and return journey convenience."
},
{
name: "Pune to Igatpuri Cab Booking",
description: "Rising Cab Service offers Pune to Igatpuri Cab Booking with instant confirmation, multiple vehicle choices, and 24x7 support for hassle-free travel planning."
},
{
name: "Cheap Pune to Igatpuri Cab",
description: "Choose Cheap Pune to Igatpuri Cab for budget-friendly travel without compromising comfort and safety, ideal for families, students, and group travelers."
},
{
name: "Best Pune to Igatpuri Cab",
description: "Rising Cab Service provides the Best Pune to Igatpuri Cab with premium vehicles, experienced drivers, punctual service, and smooth travel experience."
},
{
name: "24x7 Pune to Igatpuri Cab Service",
description: "Our 24x7 Pune to Igatpuri Cab Service ensures round-the-clock availability, instant booking, and reliable transportation anytime you need."
},
{
name: "Outstation Cab Pune to Igatpuri",
description: "Rising Cab Service offers Outstation Cab Pune to Igatpuri for safe long-distance travel with AC vehicles, professional drivers, and flexible pickup options."
},
{
name: "Pune to Nashik Cab",
description: "Book Pune to Nashik Cab with Rising Cab Service for comfortable intercity travel with Sedan, SUV, and Innova Crysta options for families and business travelers."
},
{
name: "Pune to Nashik Cab Service",
description: "Our Pune to Nashik Cab Service provides safe, reliable, and affordable travel with experienced drivers and well-maintained vehicles for smooth journeys."
},
{
name: "Pune to Nashik Taxi Service",
description: "Rising Cab Service offers Pune to Nashik Taxi Service with punctual pickup, transparent pricing, and 24x7 availability for one way and round trip travel."
},
{
name: "Pune to Nashik Cab Booking",
description: "Book Pune to Nashik Cab Booking with instant confirmation, flexible vehicle options, and hassle-free travel planning for business and leisure trips."
},
{
name: "Best Pune to Nashik Cab",
description: "Rising Cab Service provides the Best Pune to Nashik Cab with professional chauffeurs, clean vehicles, and comfortable travel experience at affordable prices."
}
],

tableData: [
["Pune to Igatpuri Cab","Pune to Igatpuri Taxi"],
["Cab from Pune to Igatpuri","Taxi from Pune to Igatpuri"],
["Pune to Igatpuri Cab Service","Pune to Igatpuri Taxi Fare"],
["Pune to Igatpuri One Way Cab","Pune to Igatpuri Round Trip Taxi"],
["Pune to Igatpuri Cab Booking","Cheap Pune to Igatpuri Cab"],
["Best Pune to Igatpuri Cab","24x7 Pune to Igatpuri Cab Service"],
["Outstation Cab Pune to Igatpuri","Pune to Nashik Cab"],
["Pune to Nashik Cab Service","Pune to Nashik Taxi Service"],
["Pune to Nashik Cab Booking","Best Pune to Nashik Cab"]
],



whychoose: [
    {
        WhyChooseheading: "Comfortable Pune to Igatpuri Taxi Service",
        WhyChoosedescription: "Rising Cab Service provides reliable Pune to Igatpuri taxi transportation for families, tourists, couples, corporate travelers, and weekend vacation seekers."
    },
    {
        WhyChooseheading: "Perfect for Nature and Hill Station Lovers",
        WhyChoosedescription: "Igatpuri is famous for its misty mountains, waterfalls, lush greenery, and peaceful atmosphere, making it a preferred getaway destination from Pune."
    },
    {
        WhyChooseheading: "Convenient Travel for Short and Long Trips",
        WhyChoosedescription: "Whether planning a weekend holiday, monsoon trip, meditation retreat, family vacation, or sightseeing tour, we offer flexible travel options."
    },
    {
        WhyChooseheading: "Premium Vehicles for Every Travel Need",
        WhyChoosedescription: "Choose from Sedan cars, Ertiga, Innova Crysta, SUVs, Tempo Travellers, and luxury vehicles for a comfortable road journey."
    },
    {
        WhyChooseheading: "Explore Popular Igatpuri Attractions",
        WhyChoosedescription: "Visit Bhatsa River Valley, Camel Valley, Tringalwadi Fort, Vipassana International Academy, Vaitarna Dam, and other scenic destinations with ease."
    },
    {
        WhyChooseheading: "Pickup Available Across Pune & PCMC",
        WhyChoosedescription: "Doorstep pickup facilities are available from Baner, Wakad, Hinjewadi, Kharadi, Hadapsar, Viman Nagar, Kothrud, Wagholi, Pimpri Chinchwad, and nearby locations."
    },
    {
        WhyChooseheading: "Safe and Enjoyable Highway Travel",
        WhyChoosedescription: "Our experienced drivers ensure a smooth and secure journey while allowing passengers to enjoy the beautiful landscapes along the route."
    },
    {
        WhyChooseheading: "Ideal for Couples, Families, and Groups",
        WhyChoosedescription: "Rising Cab Service caters to romantic getaways, family holidays, corporate retreats, educational trips, and group outings."
    }
]
};

const faqData = [
    {
        question: "Why is Igatpuri a popular tourist destination from Pune?",
        answer: "Igatpuri is known for its scenic hills, waterfalls, trekking spots, pleasant weather, meditation centers, and natural beauty."
    },
    {
        question: "Can I book a one-way taxi from Pune to Igatpuri?",
        answer: "Yes, one-way taxi services are available along with round-trip and customized travel packages."
    },
    {
        question: "Which attractions can be visited in Igatpuri?",
        answer: "Popular attractions include Camel Valley, Bhatsa River Valley, Tringalwadi Fort, Vaitarna Dam, Kalsubai Peak region, and Vipassana International Academy."
    },
    {
        question: "Which vehicle is best for a family trip to Igatpuri?",
        answer: "Ertiga and Innova Crysta are among the most preferred vehicles because they offer spacious seating and excellent travel comfort."
    },
    {
        question: "Do you provide Tempo Travellers for group tours?",
        answer: "Yes, Tempo Travellers and larger vehicles are available for family groups, corporate outings, and tourist groups."
    },
    {
        question: "Can same-day return trips be arranged?",
        answer: "Yes, same-day return taxi packages can be organized depending on the customer's sightseeing plans and schedule."
    },
    {
        question: "Is Igatpuri suitable for monsoon trips?",
        answer: "Yes, Igatpuri is one of Maharashtra's most popular monsoon destinations because of its waterfalls, green valleys, and scenic mountain views."
    },
    {
        question: "Can Nashik sightseeing be combined with the Igatpuri trip?",
        answer: "Yes, customized travel itineraries can include Nashik, Trimbakeshwar, Sula Vineyards, and other nearby attractions."
    },
    {
        question: "Are pickups available from Pune Airport and Railway Station?",
        answer: "Yes, pickups can be arranged from Pune Airport, Railway Station, hotels, offices, and residential locations."
    },
    {
        question: "How can I reserve a Pune to Igatpuri Taxi?",
        answer: "Bookings can be confirmed through phone calls, WhatsApp messages, or online inquiries with Rising Cab Service."
    }
];

const testimonials = [
    {
        id: 1,
        name: "Mr. Pratik Kulkarni",
        feedback:
            "Our monsoon trip to Igatpuri was absolutely wonderful. The cab was comfortable, the driver was knowledgeable about local attractions, and the entire journey was enjoyable.",
        rating: 5
    },
    {
        id: 2,
        name: "Mrs. Sneha Chavan",
        feedback:
            "The family getaway to Igatpuri was planned perfectly. We visited multiple scenic locations and traveled comfortably throughout the trip thanks to Rising Cab Service.",
        rating: 5
    }
];






    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Darshan Cab", link: "Pune-Darshan-Cab" },
        { place: "/images/keyword/2.jpg", text: "Pune to Bhimashankar Cab", link: "Pune-to-Bhimashankar-Cab" },
        { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad to Bhimashankar Cab", link: "Pimpri-Chinchwad-to-Bhimashankar-Cab" },
        { place: "/images/keyword/4.jpg", text: "Pune to Jejuri Cab", link: "Pune-to-Jejuri-Cab" },
        { place: "/images/keyword/5.jpg", text: "Pune Weekend Tour Packages", link: "Pune-Weekend-Tour-Packages" },
        { place: "/images/keyword/6.jpg", text: "Pune Darshan Packages", link: "Pune-Darshan-Packages" },
        { place: "/images/keyword/7.jpg", text: "Pune Sade Teen Shakti Peeth Bus on Rent", link: "Pune-Sade-Teen-Shakti-Peeth-Bus-on-Rent" },
        { place: "/images/keyword/8.jpg", text: "Pune Darshan Tempo Traveller on Rent", link: "Pune-Darshan-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/9.jpg", text: "Pune to Mysore Ooty Cab Package", link: "Pune-to-Mysore-Ooty-Cab-Package" },
        { place: "/images/keyword/10.jpg", text: "Pune to Mumbai Darshan Package", link: "Pune-to-Mumbai-Darshan-Package" },
        { place: "/images/keyword/11.jpg", text: "Pune to Ajanta Ellora Cab Service", link: "Pune-to-Ajanta-Ellora-Cab-Service" },
        { place: "/images/keyword/12.jpg", text: "Pune to Shirdi Darshan Package", link: "Pune-to-Shirdi-Darshan-Package" },
        { place: "/images/keyword/13.jpg", text: "Pune to Pandharpur Darshan", link: "Pune-to-Pandharpur-Darshan" },
        { place: "/images/keyword/14.jpg", text: "Hinjewadi Cab Service", link: "Hinjewadi-Cab-Service" },
        { place: "/images/keyword/15.jpg", text: "Cab Service in Wakad", link: "Cab-Service-in-Wakad" },
        { place: "/images/keyword/16.jpg", text: "Cab Service in Baner Pune", link: "Cab-Service-in-Baner-Pune" },
        { place: "/images/keyword/17.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
        { place: "/images/keyword/18.jpg", text: "Cab Service in Hadapsar", link: "Cab-Service-in-Hadapsar" },
        { place: "/images/keyword/19.jpg", text: "Cab Service in Viman Nagar", link: "Cab-Service-in-Viman-Nagar" },
        { place: "/images/keyword/20.jpg", text: "Cab Service in Kothrud", link: "Cab-Service-in-Kothrud" },
        { place: "/images/keyword/21.jpg", text: "Cab Service in Pimpri Chinchwad", link: "Cab-Service-in-Pimpri-Chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Cab Service in Wagholi Pune", link: "Cab-Service-in-Wagholi-Pune" },
        { place: "/images/keyword/23.jpg", text: "Pune to Trimbakeshwar Cab", link: "Pune-to-Trimbakeshwar-Cab" },
        { place: "/images/keyword/24.jpg", text: "Cab Service in Pune", link: "Cab-Service-in-Pune" },
        { place: "/images/keyword/25.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
    ];












const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Pune to Igatpuri Taxi Service",
"image": "https://www.risingcabservice.com/assets/images/pune-to-igatpuri-cab.jpg",
"description": "Book Pune to Igatpuri Taxi Service with Rising Cab Service for safe, comfortable, and scenic hill drive travel. Enjoy reliable one-way and round-trip cab service with AC sedans, SUVs, and Innova cars at affordable prices.",
"brand": {
"@type": "Brand",
"name": "Rising Cab Service"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "5471"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹14/Km",
"availability": "https://schema.org/InStock",
"url": "https://www.risingcabservice.com/pune-to-igatpuri-cab"
}
};







    return (
        <div>
<Helmet>
  <title>Pune to Igatpuri Taxi Service | Hill Drive Cab | +91 9272511548</title>

<meta
 name="description"
 content="Book Pune to Igatpuri Taxi Service for safe and scenic hill drive travel. Get affordable one-way and round-trip cab service with AC sedans, SUVs, and Innova cars."
/>

<meta
 name="keywords"
 content="pune to igatpuri cab, pune to igatpuri taxi, cab from pune to igatpuri, taxi from pune to igatpuri, pune to igatpuri cab service, pune to igatpuri taxi fare, pune to igatpuri one way cab, pune to igatpuri round trip taxi, pune to igatpuri cab booking, cheap pune to igatpuri cab, best pune to igatpuri taxi, sedan pune to igatpuri cab, suv pune to igatpuri taxi, innova pune to igatpuri cab, hill drive cab pune igatpuri, Pune to Igatpuri Cab, Pune to Igatpuri Cab Service, Pune to Igatpuri Taxi Service"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>


            <div
                className="breadcumb-wrapper"
                style={{
                    backgroundImage: "url('./img/bg/breadcrumb-bg.jpg')",
                    position: "relative",
                }}
            >
                <div
                    style={{
                        position: "absolute",
                        inset: 0,
                        backgroundColor: "rgba(0,0,0,0.3)",
                        zIndex: 1,
                    }}></div>

                <div className="container" style={{ position: "relative", zIndex: 2 }}>
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title"> {cardData.keyword}</h1>
                    </div>
                </div>
            </div>




















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/56.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#FF681A', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Rising Cab Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        {/* <div className="service-icon">
                      🚗
                    </div> */}
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Rising Cab Service</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Rising Cab Service </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919272511548" className="pc-call">+91 9272511548</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919272511548"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919272511548" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@risingcabservice.com" className="pc-email">
                                            booking@risingcabservice.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Rising Cab Service</strong><br />

                                            A Unit of Atithya Dining LLP,
                                            901, 902 Deron Height, Baner Rd,
                                            Above Ranka Jewelers, Pune,
                                            Maharashtra -411069
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetoigatpuri;